import styled from 'styled-components'
import { DARK_VIOLET, NEUTRAL_100, PALE_BLUE } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const TriggerButton = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 6px;
  background-color: ${PALE_BLUE};
  border-radius: 12px;
  border: 1px solid ${NEUTRAL_100};
  cursor: pointer;
  gap: 12px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const SelectedContent = (styled.div<{ $hasIcon?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex: 1;
  padding-left: ${props => props.$hasIcon ? '0' : '12px'};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const OptionIcon = (styled.img`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: ${PALE_BLUE};
  padding: 8px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const SelectedLabel = (styled.span`
  font-family: ${INTER.medium};
  font-size: 14px;
  color: ${DARK_VIOLET};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const PlaceholderText = (styled.span`
  font-family: ${INTER.medium};
  font-size: 14px;
  color: ${DARK_VIOLET};
  flex: 1;
  padding-left: 12px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const ChevronWrapper = (styled.div`
  padding: 10px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

interface OptionItemProps {
  $isLast: boolean
  $hasIcon?: boolean
}

export const OptionItem = (styled.div<OptionItemProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${props => props.$hasIcon ? '6px' : '16px 12px'};
  cursor: pointer;
  border-bottom: ${props => props.$isLast ? 'none' : `1px solid ${NEUTRAL_100}`};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const OptionContent = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const OptionTextContainer = (styled.div`
  display: flex;
  flex-direction: column;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const OptionLabel = (styled.span`
  font-family: ${INTER.medium};
  font-size: 13px;
  color: ${DARK_VIOLET};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const OptionSubtitle = (styled.span`
  font-family: ${INTER.regular};
  font-size: 12px;
  color: ${DARK_VIOLET};
  opacity: 0.6;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any
